import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PeripheralNeuritisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Peripheral Neuritis</h1>
        <section className="mb-8">
          <p>Peripheral neuritis is a condition affecting the peripheral nerves, causing pain, numbness, and weakness. Our natural therapies focus on nerve regeneration, pain management, and improving nerve function through gentle, effective herbal remedies and holistic approaches.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Diabetes</li>
            <li>Vitamin deficiencies</li>
            <li>Autoimmune disorders</li>
            <li>Infections</li>
            <li>Toxins and medications</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Numbness and tingling</li>
            <li>Burning pain</li>
            <li>Muscle weakness</li>
            <li>Loss of coordination</li>
            <li>Sensitivity to touch</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use nerve-nourishing herbs, pain-relieving agents, and lifestyle modifications to naturally treat peripheral neuritis. Our approach focuses on improving nerve function, reducing inflammation, and promoting natural healing through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural pain relief</li>
            <li>Improved nerve function</li>
            <li>No harsh side effects</li>
            <li>Long-term management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Regular exercise</li>
            <li>Balanced diet rich in B vitamins</li>
            <li>Stress management</li>
            <li>Avoid alcohol and smoking</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Results vary by individual, but many patients notice improvement within 2-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of peripheral neuritis.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent further nerve damage?</strong>
            <p>A: Yes, our holistic approach helps prevent further nerve damage while promoting natural healing.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from peripheral neuritis—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default PeripheralNeuritisPage; 